import { ChartArea, ChartColumn, ChartLine, ChartPie, Circle, List, Minus } from "lucide-react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import type { ChartMode } from "./useChartMode";
import type { ConversionMode, DistributionMode } from "./useDistributionMode";

const Modes = styled.div`
	display: flex;
	flex-shrink: 0;
	gap: 2px;
	padding: 2px;
	border: 1px solid #e1e6ef;
	border-radius: 7px;
	background: #f6f8fb;
	button { display: flex; align-items: center; justify-content: center; width: 28px; height: 26px; padding: 0; border: 0; border-radius: 4px; background: transparent; color: #667085; cursor: pointer; }
	button:hover { background: #eaf0f6; }
	button[aria-pressed="true"] { color: #167ca6; background: #fff; box-shadow: 0 1px 3px #1018281a; }
	button:focus-visible { outline: 2px solid #6374d9; outline-offset: 2px; }
`;

const modes = [
	{ mode: "line", Icon: ChartLine },
	{ mode: "bar", Icon: ChartColumn },
	{ mode: "area", Icon: ChartArea },
] as const;

export const ChartModeSelector = ({ value, onChange }: { value: ChartMode; onChange: (mode: ChartMode) => void }) => {
	const { t } = useTranslation();
	return <Modes className="chart-modes" role="group" aria-label={t("dashboard.sessionRate.chartType")}>
		{modes.map(({ mode, Icon }) => <button key={mode} type="button" aria-pressed={value === mode} aria-label={t(`dashboard.sessionRate.${mode}Chart`)} title={t(`dashboard.sessionRate.${mode}Chart`)} onClick={() => onChange(mode)}><Icon size={16} aria-hidden="true" /></button>)}
	</Modes>;
};

const distributionModes = [{ mode: "donut", Icon: ChartPie }, { mode: "list", Icon: List }] as const;

export const DistributionModeSelector = ({ value, onChange }: { value: DistributionMode; onChange: (mode: DistributionMode) => void }) => {
	const { t } = useTranslation();
	return <Modes role="group" aria-label={t("dashboard.sessionRate.chartType")}>
		{distributionModes.map(({ mode, Icon }) => <button key={mode} type="button" aria-pressed={value === mode} aria-label={t(`stats.distribution.${mode}`)} title={t(`stats.distribution.${mode}`)} onClick={() => onChange(mode)}><Icon size={16} aria-hidden="true" /></button>)}
	</Modes>;
};

const conversionModes = [{ mode: "donut", Icon: Circle }, { mode: "linear", Icon: Minus }] as const;

export const ConversionModeSelector = ({ value, onChange }: { value: ConversionMode; onChange: (mode: ConversionMode) => void }) => {
	const { t } = useTranslation();
	return <Modes role="group" aria-label={t("dashboard.sessionRate.chartType")}>
		{conversionModes.map(({ mode, Icon }) => <button key={mode} type="button" aria-pressed={value === mode} aria-label={t(`stats.conversion.${mode}`)} title={t(`stats.conversion.${mode}`)} onClick={() => onChange(mode)}><Icon size={16} aria-hidden="true" /></button>)}
	</Modes>;
};
